import React from 'react';
import { useOrderContext } from '../../../components/OrderProvider';
import ConversationList from '@afosto/app-components-react/ConversationList';

const OrderCommunication = () => {
  const { order } = useOrderContext();

  return (
    <ConversationList
      constraints={[
        {
          key: 'entity_type',
          operator: 'in',
          value: ['order'],
        },
        {
          key: 'entity_ids',
          operator: 'in',
          value: [order.id],
        },
      ]}
      canCreateComment
      entityType="order"
      entityID={order.id}
    />
  );
};

export default OrderCommunication;
